window.hederaVariantState = {
  begin(form, elements = []) {
    if (!form) return;
    form.dataset.hdProductInfoPending = 'true';
    form.classList.add('hd-variant-pending');
    form.setAttribute('aria-busy', 'true');
    const add = form.querySelector('[name="add"]');
    if (add) add.disabled = true;
    form.querySelectorAll('[data-hd-buy-now], .shopify-payment-button').forEach(node => {
      if (!node.hasAttribute('data-hd-was-inert')) node.dataset.hdWasInert = String(node.inert);
      node.inert = true;
    });
    form.hdPendingInfo = elements.filter(Boolean);
    form.hdPendingInfo.forEach(node => {
      node.classList.add('hd-variant-info');
      node.style.visibility = '';
      node.setAttribute('data-hd-variant-pending', '');
      node.setAttribute('aria-busy', 'true');
    });
  },
  end(form, failed = false) {
    if (!form) return;
    form.classList.remove('hd-variant-pending');
    form.removeAttribute('aria-busy');
    if (!failed) delete form.dataset.hdProductInfoPending;
    (form.hdPendingInfo || []).forEach(node => {
      node.removeAttribute('data-hd-variant-pending');
      node.removeAttribute('aria-busy');
      if (failed) node.style.visibility = 'hidden';
    });
    form.querySelectorAll('[data-hd-was-inert]').forEach(node => {
      if (failed) return;
      node.inert = node.dataset.hdWasInert === 'true';
      delete node.dataset.hdWasInert;
    });
  }
};
